import { useBaseApiMutation } from "@mutation/baseMutation";

export const useShopItemUpdateMutation = (clubUuid, shopItemUuid) => {

    return useBaseApiMutation(
        {
            method: "PUT",
            endpoint: `club/${clubUuid}/shopItem/${shopItemUuid}`
        }
    )
}

export const useAttachShopItemToSiteMutation = () => {
    return useBaseApiMutation(
        {
        method: "POST",
        endpoint: "site/{siteUuid}/shopItem/{shopItemUuid}"
    }
)
};

export const useUpdateSiteShopItemAvailabilityMutation = () => {
    return useBaseApiMutation(
        {
            method: "PUT",
            endpoint: "site/{siteUuid}/siteShopItem/{siteShopItemUuid}",
        }
    )
};

export const useCreateShopItemMutation = () => {
    return useBaseApiMutation(
        {
            method: "POST",
            endpoint: "club/{clubUuid}/shopItem",
        }
    )
};